/**
 * Service areas, mirrored from nanniestotherescue.com. Used by the /locations
 * index and the per-region pages. Add a region here and it shows up in both.
 */
export const REGIONS = [
  {
    slug: 'eastern-michigan',
    name: 'Eastern Michigan',
    country: 'United States',
    short: 'Michigan, USA',
    lede:
      'Nanny placements, back-up childcare and event care across Eastern Michigan — from busy city neighbourhoods to quiet suburban communities.',
    cities: [
      'Port Huron',
      'Fort Gratiot',
      'Marysville',
      'Chesterfield',
      'Troy',
      'Ann Arbor',
      'Bloomfield Hills',
    ],
  },
  {
    slug: 'ontario',
    name: 'Ontario',
    country: 'Canada',
    short: 'Ontario, Canada',
    lede:
      'Serving families in Kitchener, Waterloo and surrounding communities, as well as guests staying in local hotels or attending conferences, weddings and special events.',
    cities: [
      'Kitchener',
      'Waterloo',
      'Waterloo Region',
      'Cambridge',
      'Guelph',
      'Stratford',
      'Toronto',
      'Ottawa',
      'London',
      'Windsor',
      'Sarnia',
      'Chatham-Kent',
    ],
  },
];

export const getRegion = (slug) => REGIONS.find((r) => r.slug === slug);
